// Split long file names with underscores for better display
type FileNameForceWrapProps = {
    filename: string;
};

const FileNameForceWrap: React.FC<FileNameForceWrapProps> = ({ filename }) => (
    <span>
        {filename.split('_').map((part, idx) => (
            <span key={idx}>
                {part}
                {idx < filename.split('_').length - 1 && '_'}
            </span>
        ))}
    </span>
);

export default FileNameForceWrap;